import { Button } from "@mui/material";
import usePermission from "hooks/usePermission";

const PermissionButton = ({
    permission,
    children,
    ...props
}) => {
    const { hasPermission } = usePermission();

    if (!hasPermission(permission)) {
        return null;
    }

    return (
        <Button {...props}>
            {children}
        </Button>
    );
};

export default PermissionButton;